import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { SearchAutocompleteResponse } from '../../responses/platform/search-autocomplete.response';
import { KitVideoResponse } from '../../responses/platform/kit-video.response';

@Injectable({
  providedIn: 'root',
})
export class KitVideoService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public get(idKit: number): Observable<KitVideoResponse> {
    return this.httpClient
      .get<KitVideoResponse>(environment.urlApiPlatform + 'KitVideo/idKit/' + idKit, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public post(idVideo: number): Observable<ReturnStruct> {
    let body = {
      idVideo: idVideo
    }
    return this.httpClient
      .post<ReturnStruct>(environment.urlApiPlatform + 'KitVideo', body, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
